export class InsaChronosInterfaceJobDetails{
  ActivityID: number;
  BankID: number;
  Download: boolean;
  DownloadDirectory: string;
  ImportAndProcess: boolean;
  UnzipPriorToImport: boolean;
}


// WEBPACK FOOTER //
// ./app/insa-models/insa-chronos-interface-job.model.ts